import { Action, Subject } from '@erp/authz';
import type { WorkbookOutput } from '@erp/shared-types';
import { useCan } from '@/hooks/useCan';
import type { WorkbookEditor } from './useWorkbookEditor';
import { workbookOutputState } from './workbookOutputs';
import {
  useWorkbookRunResults,
  type RunResultsEditor,
} from './workbookRunResults';

/** What an Output's editor reads from the Workbook editor. */
export type OutputEditor = Pick<
  WorkbookEditor,
  'definition' | 'edits' | 'save' | 'workbookId'
> &
  RunResultsEditor;

/**
 * What every Output editor shares: whether it can be edited now, the
 * Definition, the Run Results, and the Output's Current / Stale state.
 */
export function useOutputEditor(
  editor: OutputEditor,
  output: WorkbookOutput,
  busy: boolean,
) {
  const [canUpdate] = useCan(Action.Update, Subject.Workbook);
  const { definition } = editor;
  const results = useWorkbookRunResults(editor);
  return {
    editable: canUpdate && !busy,
    definition,
    results,
    state: workbookOutputState(definition, output, results),
  };
}
